import { Layout } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

import Footer from '@/components/Footer';
import AppLayout from '@/layout/AppLayout';
import { ProfileDialog } from '@/modules/admin/containers/Profile';

import style from './index.less';

const { Content } = Layout;

const MainLayout = ({ children }) => {
  
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppLayout>
        <Content className={classNames(style.mainLayout, 'pb-16')}>
          {children}
          <ProfileDialog headerProps={{ canRemove: false, canEdit: true }}/>
        </Content>
        <Footer isCenter={false}/>
      </AppLayout>
    </Layout>
  );
};

export default memo(MainLayout);

MainLayout.propTypes = {
  children: PropTypes.any
};
